import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getThemeStyles, DEFAULT_THEME } from "../themeConfig";

export default function LoginPage() {
  const [isLogin, setIsLogin] = useState(true);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [inviteCode, setInviteCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login, register, user } = useAuth();
  const navigate = useNavigate();
  const themeKey = user?.theme ?? DEFAULT_THEME;
  const t = getThemeStyles(themeKey);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      if (isLogin) {
        await login(userName, password);
      } else {
        await register(userName, password, inviteCode);
      }
      navigate("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "操作失败");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`min-h-screen ${t.bg} text-white p-6 font-mono transition-all duration-300`}>
      <div className="max-w-md mx-auto mt-20">
        {/* HEADER */}
        <header className="text-center mb-10">
          <h1 className={`text-5xl font-bold tracking-wide drop-shadow-lg ${t.header}`}>
            ✨ SparkLab
          </h1>
          <p className={`text-lg mt-2 ${t.subheader}`}>
            {isLogin ? "欢迎回来！" : "加入我们，开始创作！"}
          </p>
        </header>

        {/* LOGIN/REGISTER CARD */}
        <div className={`p-8 rounded-3xl shadow-xl border-4 ${t.card}`}>
          <div className="flex gap-4 mb-6">
            <button
              onClick={() => {
                setIsLogin(true);
                setError("");
              }}
              className={`flex-1 py-3 rounded-xl border-2 font-bold transition ${
                isLogin
                  ? `${t.button1} text-white`
                  : "bg-black bg-opacity-20 border-transparent text-white"
              }`}
            >
              登录
            </button>
            <button
              onClick={() => {
                setIsLogin(false);
                setError("");
              }}
              className={`flex-1 py-3 rounded-xl border-2 font-bold transition ${
                !isLogin
                  ? `${t.button1} text-white`
                  : "bg-black bg-opacity-20 border-transparent text-white"
              }`}
            >
              注册
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className={`block mb-2 ${t.subheader} font-bold`}>用户名</label>
              <input
                type="text"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                className={`w-full px-4 py-3 rounded-xl border-2 ${t.input} focus:outline-none focus:ring-2 focus:ring-opacity-50`}
                placeholder="请输入用户名"
                required
              />
            </div>

            <div>
              <label className={`block mb-2 ${t.subheader} font-bold`}>密码</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={`w-full px-4 py-3 rounded-xl border-2 ${t.input} focus:outline-none focus:ring-2 focus:ring-opacity-50`}
                placeholder="请输入密码"
                required
                minLength={3}
              />
            </div>

            {!isLogin && (
              <div>
                <label className={`block mb-2 ${t.subheader} font-bold`}>邀请码</label>
                <input
                  type="text"
                  value={inviteCode}
                  onChange={(e) => setInviteCode(e.target.value)}
                  className={`w-full px-4 py-3 rounded-xl border-2 ${t.input} focus:outline-none focus:ring-2 focus:ring-opacity-50`}
                  placeholder="请输入邀请码"
                  required
                />
              </div>
            )}

            {error && (
              <div className="p-3 rounded-xl bg-red-500 bg-opacity-20 border-2 border-red-500 text-red-200">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className={`w-full py-4 rounded-xl border-2 ${t.button1} text-white font-bold text-xl hover:scale-105 transition disabled:opacity-50 disabled:cursor-not-allowed`}
            >
              {loading ? "处理中..." : isLogin ? "登录" : "注册"}
            </button>
          </form>

          <div className="mt-6 text-center">
            <button
              onClick={() => navigate("/")}
              className={`${t.subheader} hover:underline`}
            >
              ← 返回首页
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

